import { showHidePassword } from './modules/show-hide-password';
import { SvgSprite } from './modules/svg-loader';
import { RevealPanel } from './modules/revealPanel';
import { Accordion } from './modules/accordion';
import { Tabs } from './modules/tabs';
import { mainNavigation } from './modules/mainNavigation';
import { GoogleTranslate } from './modules/google-translate'
import * as YouTubeIframeLoader from 'youtube-iframe';
import './modules/promo-interface';
import './modules/sticky-sidebar-component';
import { Gallery } from './modules/gallery';
import { QuickDonate } from './modules/quickDonate';
import { HeaderVideo } from './modules/headerVideo';
import { VideoItem } from './modules/videoItem';
import throttle = require('lodash.throttle');
import debounce = require('lodash.debounce');
import { AlertBanner } from './modules/alert-banner';
import { initModals } from './modules/a11y-modal';
import { loginState } from './modules/login-state';
import { initEventRsvpCancel } from './modules/eventRsvpCancel';
import { initExchangeCartCleanup } from './tnew/exchangeCartCleanup';

new SvgSprite('/Static/img/adage-sprite.svg');

new GoogleTranslate();


showHidePassword();

const navigationInit = () => {
    if (mainNavigation) mainNavigation.init();

    document.addEventListener('scroll', throttle(() => {
        if (mainNavigation) mainNavigation.scrollHandler();
    }, 10));
    window.addEventListener('resize', debounce(() => {
        if (mainNavigation) mainNavigation.resizeHandler();
       
    }, 50));
}

const initializeGenericComponents = () => {
    navigationInit();

    new AlertBanner();

    loginState();

    // Initialize all a11y-dialog modals with body scroll locking
    initModals();

    // Event RSVP landing page: SA cancel confirm buttons (no-op on other pages)
    initEventRsvpCancel();

    // TNEW exchange cart cleanup: zero out exchanged-out credit prices and hide
    // contributions on the cart page (no-op on other pages). Deferred to
    // DOMContentLoaded because global.js runs mid-body, BEFORE TNEW's inline
    // `orderDataModel` script lower on the page that the exchange gate reads.
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initExchangeCartCleanup);
    } else {
        initExchangeCartCleanup();
    }

    const panels = [].slice.call(document.querySelectorAll('[data-panel]')) as HTMLElement[];
    panels.forEach(panel => {
        new RevealPanel(panel);
    });

    const accordions = [].slice.call(document.querySelectorAll('[data-accordion-list]')) as HTMLElement[];
    accordions.forEach(accordionEl => {
        const oneOpenAtATime = accordionEl.getAttribute('data-one-open-at-a-time') == "true";
        new Accordion({ container: accordionEl, oneOpenAtATime: oneOpenAtATime });
    });

    const tabEls = Array.prototype.slice.call(document.querySelectorAll('[data-tabs-container]')) as HTMLElement[];
    tabEls.forEach(tabEl => {
        new Tabs({ container: tabEl });
    })

    // Gallery Init
    document.addEventListener('DOMContentLoaded', function () {
        const galleryClass = 'gallery';
        const galleries = Array.prototype.slice.call(document.querySelectorAll('[data-gallery]'));
        galleries.forEach((gallery, index) => {
            gallery.classList.add(`${galleryClass}-${index}`);
            new Gallery(gallery);
        });
    });

    const quickDonateBlocks = [].slice.call(document.querySelectorAll('[data-quick-donate]'));
    quickDonateBlocks.forEach(block => {
        new QuickDonate(block);
    });

    // Header videos
    const headerVideoContainers = Array.prototype.slice.call(document.querySelectorAll('[data-header-video-container]')) as HTMLElement[];
    headerVideoContainers.forEach(HeaderVideoContainer => {
        new HeaderVideo(HeaderVideoContainer);
    });

    // Videos
    const videoItems = Array.prototype.slice.call(document.querySelectorAll('[data-video-item]:not([data-video-type=youtube])')) as HTMLElement[];
    const youtubeVideoItems = Array.prototype.slice.call(document.querySelectorAll('[data-video-item][data-video-type=youtube]')) as HTMLElement[]
    videoItems.forEach(videoItem => {
        new VideoItem(videoItem);
    });
    YouTubeIframeLoader.load(YT => {
        youtubeVideoItems.forEach(youtubeVideoItem => {
            const iframe = youtubeVideoItem.querySelector('[data-youtube-id]');
            const ytvideoPlayer = new YT.Player(iframe.getAttribute('id'), {
                height: '390',
                width: '640',
                videoId: iframe.getAttribute('data-youtube-id'),
                events: {
                    onReady: () => {
                        new VideoItem(youtubeVideoItem, ytvideoPlayer);
                    }
                }
            });

        });

    });
}



initializeGenericComponents();
